import { createFileRoute } from "@tanstack/react-router";
import { ActividadesPanel } from "@/components/admin/ActividadesPanel";

export const Route = createFileRoute("/admin/tareas")({
  component: ActividadesPanel,
});
